// @ts-strict-ignore
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import type { EngagementSegmentsParams } from "./types";

export const formatParams = ({
  appGroupId,
  query,
  sortby,
  sortdir,
  limit = 20,
  start = 0,
  fields = [],
}: EngagementSegmentsParams) => ({
  query: serializeQueryObjects({
    ...query,
    ...formatLastEditedTime(query),
    ...formatCreatedAtTime(query),
    ...formatLegacyDeveloperSelect(query),
  }),
  limit,
  start,
  sortby,
  sortdir,
  app_group_id: appGroupId,
  fields: fields.join(","),
});

// Override query to backend so date fields are nested in "edited"
const formatLastEditedTime = (query: { start_date?: number; end_date?: number }) => {
  if (query.start_date && query.end_date) {
    return {
      edited: {
        start_date: query.start_date,
        end_date: query.end_date,
      },
    };
  }
};

// Override query to backend so date fields are nested in "created_at"
const formatCreatedAtTime = (query: { created_at_start_date?: number; created_at_end_date?: number }) => {
  if (query.created_at_start_date && query.created_at_end_date) {
    return {
      created_at: {
        start_date: query.created_at_start_date,
        end_date: query.created_at_end_date,
      },
    };
  }
};

// Some users may have array based values in local storage
const formatLegacyDeveloperSelect = (query: { edited_by?: string[]; created_by?: string[] }) => {
  const state: { edited_by?: string; created_by?: string } = {};

  if (Array.isArray(query.edited_by) && query.edited_by?.length > 0) {
    state["edited_by"] = query.edited_by[0];
  }

  if (Array.isArray(query.created_by) && query.created_by?.length > 0) {
    state["created_by"] = query.created_by[0];
  }

  return state;
};
